// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"754":"eafd615d","765":"d1451552","890":"07827fa7","952":"d0fc9b6f"}[chunkId] + ".chunk.css";
};